import { matchApi } from '@/api/matches.api';

const unwrap = (response) => response.data;

export const matchService = {
  list: async (params) => {
    const res = await matchApi.list(params);
    return { matches: unwrap(res).data.matches, meta: unwrap(res).meta };
  },
  getById: async (id) => {
    const res = await matchApi.getById(id);
    return unwrap(res).data.match;
  },
  create: async (data) => {
    const res = await matchApi.create(data);
    return unwrap(res).data.match;
  },
  update: async (id, data) => {
    const res = await matchApi.update(id, data);
    return unwrap(res).data.match;
  },
  remove: async (id) => {
    await matchApi.remove(id);
    return true;
  },
  start: async (id, toss) => {
    const res = await matchApi.start(id, toss ? { toss } : undefined);
    return unwrap(res).data.match;
  },
  end: async (id) => {
    const res = await matchApi.end(id);
    return unwrap(res).data.match;
  },
};
